module.exports = __webpack_public_path__ + "img/icon_map_13_off_101.f0f72a37.png";